import { render, staticRenderFns } from "./CampaignDetailsTesting.vue?vue&type=template&id=16682fd6&scoped=true"
import script from "./CampaignDetailsTesting.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsTesting.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsTesting.vue?vue&type=style&index=0&id=16682fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16682fd6",
  null
  
)

export default component.exports